export default __webpack_public_path__ + "static/media/Superkiwi_banner.fad23900.jpg";